// Lib
import { createAction } from '@reduxjs/toolkit';

export const SetApiError = createAction('SET_API_ERROR');
export const ClearApiError = createAction('CLEAR_API_ERROR');
